// A cart / checkout tab can outlive its nonces. WordPress replaces them every 12 hours
// (03:00 and 15:00 Athens) and at once when the shopper signs in or out, so a tab left
// open, or brought back with the Back button, gets every call refused: REST answers
// 403 `rest_cookie_invalid_nonce`, admin-ajax answers 403 "-1". The shopper is stuck
// until they reload; 7-25 visitors a day left that way and never ordered (Oct 2026).
//
// isNonceRefusal() recognises exactly those two answers. A handler's own 403 carries a
// { success:false } envelope and is NOT one: it must reach the shopper, not be retried.
// A refused call never reached its handler, so retrying it (even cn_place_order) is safe.
//
// refreshNonces() asks wc-ajax=cn_fresh_nonces (checkout-next/rest-routes.php) for the
// nonces this browser's cookies hold now and writes them into the page config IN PLACE,
// so every later call on the page uses them too. Concurrent refusals share one request.

export const NONCE_REFUSED = { nonceRefused: true };

export function isNonceRefusal(status, body) {
  if (status !== 403) return false;
  if (body === -1 || body === '-1') return true;
  return !!(body && typeof body === 'object' && body.code === 'rest_cookie_invalid_nonce');
}

// fetch() wrapper's 403 branch: read the body once and say whether it was a refused nonce.
export async function readRefusal(res) {
  let body = null;
  try { body = await res.json(); } catch (e) { /* "-1" parses; an HTML page does not */ }
  return isNonceRefusal(res.status, body);
}

let inflight = null;

export function refreshNonces(cfg) {
  if (!inflight) {
    inflight = fetch('/?wc-ajax=cn_fresh_nonces', { method: 'POST', credentials: 'same-origin' })
      .then((r) => (r.ok ? r.json() : null))
      .then((j) => (j && j.success && j.data && j.data.nonce ? j.data : null))
      .catch(() => null)
      .finally(() => { inflight = null; });
  }
  return inflight.then((d) => {
    if (!d) return false;
    cfg.nonce = d.nonce;
    if (d.restNonce) cfg.restNonce = d.restNonce;
    return true;
  });
}
